exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-bar-container {\n  border: 1px solid #F7A500;\n  border-radius: 16px;\n  background-color: #F1F5F7; }\n\n.progress-bar {\n  height: 12px;\n  width: 0%;\n  border-radius: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/progress-bar/progress-bar.component.scss
// module id = ../../../../../src/app/core/components/progress-bar/progress-bar.component.scss
// module chunks = main